module.exports = __webpack_public_path__ + "static/media/01.dce1839d.png";